import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import VariableWidget from './VariableWidget.vue'

export default Node.create({
  name: 'otiumVariable',

  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      name: {
        default: "test",
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'otium-variable',

      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['otium-variable', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(VariableWidget)
  },
})